export default __webpack_public_path__ + "static/media/3-1.43962c90.webp";